import { createFileRoute, redirect, useNavigate } from "@tanstack/react-router";
import { useEffect } from "react";
import { useFortnoxCallback } from "../../api/billing/useFortnoxCallback";
import LoadingScreen from "../../features/Layout/LoadingScreen/LoadingScreen";
import { notifications } from "@mantine/notifications";
import successNotificationClasses from "../../theme/notification.success.module.scss";

type FortnoxSearch = {
  code: string;
  state: string;
  error: string;
};

export const Route = createFileRoute("/oauth/fortnox/callback")({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): FortnoxSearch => {
    return {
      code: (search.code as string) || "",
      state: (search.state as string) || "",
      error: (search.error as string) || "",
    };
  },
  beforeLoad: ({ search }) => {
    if (search.error !== "") {
      if (search.error === "access_denied") {
        notifications.show({
          id: "fortnox_access_denied",
          title: "Avbruten",
          message: "Inloggning avbruten av användaren",
          position: "bottom-center",
          classNames: successNotificationClasses,
          color: "bluegray.9",
        });
      }
      throw redirect({ to: "/admin/clients" });
    }
  },
});

function RouteComponent() {
  const navigate = useNavigate();
  const { code, state } = Route.useSearch();

  const { mutate } = useFortnoxCallback({
    onSuccess: () => navigate({ to: "/admin/billing" }),
  });

  useEffect(() => {
    mutate({ code, state });
  }, [code, state]);

  return <LoadingScreen />;
}
